import { useState } from 'react'
import { useGoalsCrud } from '../mutations/useGoalsCrud.js'

const TEAM = [
  '—', 'Ricky', 'Zoe', 'Christina', 'Katie', 'Margo', 'Emily',
  'Sandra', 'Sergina', 'Jonathan', 'Chris', 'Harold',
  'Jessie', 'Christine', 'Braden', 'Colin', 'Jane', 'TBD',
]

/**
 * AddSubgoalButton — "+ Add sub-goal" at the bottom of a goal's
 * sub-goal table. Opens an inline form.
 */
export default function AddSubgoalButton({ pillarName, goalIndex, defaultOwner }) {
  const { addSubgoal } = useGoalsCrud()
  const [open, setOpen] = useState(false)
  const [name, setName] = useState('')
  const [owner, setOwner] = useState(defaultOwner || '—')
  const [target, setTarget] = useState('')
  const [unit, setUnit] = useState('')

  const reset = () => {
    setName('')
    setOwner(defaultOwner || '—')
    setTarget('')
    setUnit('')
    setOpen(false)
  }

  const submit = () => {
    if (!name.trim()) return
    addSubgoal({
      pillarName,
      goalIndex,
      subgoal: {
        subgoal: name.trim(),
        metric: '',
        target: target ? Number(target) : 1,
        current: 0,
        unit: unit || '',
        owner: owner || '—',
        update: '',
      },
    })
    reset()
  }

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{
          width: '100%',
          padding: '10px 12px',
          background: 'transparent',
          border: '1px dashed var(--border-strong)',
          borderRadius: 8,
          fontSize: 11,
          fontWeight: 600,
          color: 'var(--muted)',
          cursor: 'pointer',
          textAlign: 'left',
          transition: 'all 0.15s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#f9fafb'
          e.currentTarget.style.color = 'var(--text-secondary)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent'
          e.currentTarget.style.color = 'var(--muted)'
        }}
      >
        + Add sub-goal
      </button>
    )
  }

  return (
    <div
      style={{
        padding: 12,
        background: '#fff',
        border: '1.5px solid var(--accent)',
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      <input
        autoFocus
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit()
          if (e.key === 'Escape') reset()
        }}
        placeholder="Sub-goal name"
        style={{
          padding: '7px 10px',
          border: '1px solid var(--border)',
          borderRadius: 6,
          fontSize: 12,
          fontFamily: 'inherit',
          fontWeight: 600,
          outline: 'none',
        }}
      />
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        <select
          value={owner}
          onChange={(e) => setOwner(e.target.value)}
          style={{ flex: '1 1 120px', ...pickerStyle }}
        >
          {TEAM.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
        <input
          type="text"
          inputMode="numeric"
          value={target}
          onChange={(e) => setTarget(e.target.value)}
          placeholder="Target"
          style={{ flex: '0 1 90px', ...pickerStyle }}
        />
        <select
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          style={{ flex: '0 1 70px', ...pickerStyle }}
        >
          <option value="">—</option>
          <option value="$">$</option>
          <option value="%">%</option>
        </select>
      </div>
      <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
        <button type="button" onClick={reset} style={cancelBtn}>Cancel</button>
        <button
          type="button"
          onClick={submit}
          disabled={!name.trim()}
          style={{
            ...addBtn,
            background: name.trim() ? 'var(--accent)' : '#e5e7eb',
            color: name.trim() ? '#fff' : '#9ca3af',
            cursor: name.trim() ? 'pointer' : 'not-allowed',
          }}
        >
          Add Sub-Goal
        </button>
      </div>
    </div>
  )
}

const pickerStyle = {
  padding: '6px 8px',
  border: '1px solid var(--border)',
  borderRadius: 6,
  fontSize: 11,
  fontFamily: 'inherit',
  background: '#fff',
  outline: 'none',
}

const cancelBtn = {
  padding: '6px 12px',
  border: '1px solid var(--border)',
  borderRadius: 6,
  fontSize: 11,
  fontWeight: 600,
  background: '#fff',
  color: 'var(--muted)',
  cursor: 'pointer',
}

const addBtn = {
  padding: '6px 14px',
  border: 'none',
  borderRadius: 6,
  fontSize: 11,
  fontWeight: 700,
}
